export enum Time {
  // Objects with defined availability constraints that includes the current time
  NOW = 'now',
  // Objects with availability start time in the future
  FUTURE = 'future',
  // Objects with availability end time in the past
  PAST = 'past',
  // Objects with availability start time in the past and no end time
  INDEFINITELY = 'indefinitely',

  // Objects with no availability constraints
  ALWAYS = 'always',
  // Objects with no availability constraints
  NEVER = 'never',
}
